/*
 * Copyright (c) 2023.
 * Author Peter Placzek (tada5hi)
 * For the full copyright and license information,
 * view the LICENSE file that was distributed with this source code.
 */
import path from 'node:path';

export function isFilePath(input: string) {
    const extension = path.extname(input);
    return extension && extension !== '';
}
